import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import { __values } from "tslib";
/* eslint-disable */

import { traverse, isPlainObject } from '@/lib/utils';

var Confirm =
/** @class */
function () {
  function Confirm(val) {
    this.val = val;
  }

  Confirm.prototype.confirm = function () {
    this.val.old = this.val.current;
  };

  Confirm.prototype.rollback = function () {
    this.val.current = this.val.old;
  };

  return Confirm;
}();
/**
 * 改造对象，将current和old数据都存储
 */


function defineConfirmable(obj, key, val) {
  if (val === void 0) {
    val = null;
  }

  var _val = {
    current: val,
    old: val
  };
  Object.defineProperty(obj, key, {
    configurable: true,
    enumerable: true,
    get: function get() {
      return _val.current;
    },
    set: function set(v) {
      _val.current = v;
    }
  });
  return new Confirm(_val);
}

var Confirmable =
/** @class */
function () {
  function Confirmable(obj) {
    var e_1, _a;

    var keys = Object.keys(obj);
    var confirms = [];

    try {
      for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
        var key = keys_1_1.value;

        if (isPlainObject(obj[key])) {
          var map = new Confirmable(obj[key]);
          this[key] = map;
          confirms.push(map);
        } else {
          confirms.push(defineConfirmable(this, key, obj[key]));
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (keys_1_1 && !keys_1_1.done && (_a = keys_1["return"])) _a.call(keys_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    Object.defineProperty(this, '__confirm__', {
      writable: true,
      configurable: false,
      enumerable: false,
      value: confirms
    });
  }

  Confirmable.prototype.set = function (keyOrPath, val) {
    var parts = keyOrPath.split('.');

    if (parts.length === 1) {
      this[keyOrPath] = val;
    } else {
      var last = parts.pop();
      var obj = traverse(this, parts);
      obj[last] = val;
    }
  };

  Confirmable.prototype.confirm = function () {
    var e_2, _a;

    var obs = this.__confirm__;

    try {
      for (var obs_1 = __values(obs), obs_1_1 = obs_1.next(); !obs_1_1.done; obs_1_1 = obs_1.next()) {
        var ob = obs_1_1.value;
        ob.confirm();
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (obs_1_1 && !obs_1_1.done && (_a = obs_1["return"])) _a.call(obs_1);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };

  Confirmable.prototype.rollback = function () {
    var e_3, _a;

    var obs = this.__confirm__;

    try {
      for (var obs_2 = __values(obs), obs_2_1 = obs_2.next(); !obs_2_1.done; obs_2_1 = obs_2.next()) {
        var ob = obs_2_1.value;
        ob.rollback();
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (obs_2_1 && !obs_2_1.done && (_a = obs_2["return"])) _a.call(obs_2);
      } finally {
        if (e_3) throw e_3.error;
      }
    }
  };

  return Confirmable;
}();

export { Confirmable };